import { Vue, Component } from "vue-property-decorator";
import { ASSISTANT_ORIGIN, EXTERNAL_APP_URI } from "../../common/uri/property-uri.constants";
import { embeddedAppTokenBroker } from "../../utils/embedded-app-token";
import { LanguageHelper } from "../../utils/language-helper";
import { ASSISTANT_EVENTS } from "../../common/assistant.constant";
import { consumePendingArtifact } from "./artifact-store";

@Component({
    name: "AssistantArtifact",
    template: require("./template.html"),
})
export default class AssistantArtifact extends Vue {
    artifactUrl: string = "";
    isLoading: boolean = true;

    private handleMessage: ((event: MessageEvent) => void) | null = null;
    private artifactData: unknown = null;
    private unregisterAccessToken: () => void = null;

    mounted() {
        this.artifactData = consumePendingArtifact();
        this.handleMessage = this.onMessage.bind(this);
        window.addEventListener("message", this.handleMessage);
        this.unregisterAccessToken = embeddedAppTokenBroker.register({
            origin: ASSISTANT_ORIGIN,
            getContentWindow: () => (this.$refs.artifactIframe as HTMLIFrameElement)?.contentWindow || null,
            getLanguageId: () => LanguageHelper.convertLanguageInt(this.$i18n.locale),
        });
        this.initIframe();
    }

    initIframe() {
        this.isLoading = true;
        this.artifactUrl = `${EXTERNAL_APP_URI.ASSISTANT_APP}/embed/artifact`;
    }

    onIframeLoad() {
        this.isLoading = false;
    }

    onMessage(event: MessageEvent) {
        if (event.origin !== ASSISTANT_ORIGIN) return;

        const iframe = this.$refs.artifactIframe as HTMLIFrameElement | undefined;
        if (!iframe || event.source !== iframe.contentWindow) return;

        const { data } = event;
        if (!data || typeof data !== "object" || !data.type) return;

        if (data.type === ASSISTANT_EVENTS.EMBED_READY) {
            this.sendArtifactData();
        }
    }

    sendArtifactData() {
        const iframe = this.$refs.artifactIframe as HTMLIFrameElement;
        if (!iframe?.contentWindow || !this.artifactData) return;

        const targetOrigin = EXTERNAL_APP_URI.ASSISTANT_APP;
        iframe.contentWindow.postMessage(
            {
                type: "ARTIFACT_DATA",
                payload: { artifact: this.artifactData },
            },
            targetOrigin
        );
    }

    beforeDestroy() {
        if (this.handleMessage) {
            window.removeEventListener("message", this.handleMessage);
        }
        this.unregisterAccessToken?.();
    }
}
